import type { ApplicationSettingsPerStateAdminApiContract } from '@/api/generated/pwrdbyQuickMDAdminsApi.schemas'
import StateSettingsRow from '../state-settings-row/StateSettingsRow'
import { text } from './constants'

type StateSettingsBodyProps = {
  stateSettingsList: ApplicationSettingsPerStateAdminApiContract[]
  onSelectState: (stateCode: string) => void
}

export const StateSettingsBody = ({ stateSettingsList, onSelectState }: StateSettingsBodyProps) => (
  <div className='flex flex-col rounded-b-large border border-shade-10'>
    {/* Column header row */}
    <div className='flex items-center gap-4 border-b border-shade-10 bg-deep-navy-5 px-6 py-[10px]'>
      {/* State column — holds 240px, shrinks to a floor on narrow viewports */}
      <div className='flex w-[240px] min-w-[120px] items-center overflow-hidden'>
        <span className='whitespace-nowrap text-xs font-semibold leading-4 text-text-light'>{text.STATE}</span>
      </div>
      {/* Drug screening column — holds 200px, shrinks to a floor on narrow viewports */}
      <div className='flex w-[200px] min-w-[120px] items-center overflow-hidden'>
        <span className='whitespace-nowrap text-xs font-semibold leading-4 text-text-light'>{text.DRUG_SCREENING}</span>
      </div>
      {/* Phone visits column — flex: 1 1 0 */}
      <div className='flex min-w-0 flex-1 items-center overflow-hidden'>
        <span className='whitespace-nowrap text-xs font-semibold leading-4 text-text-light'>{text.PHONE_VISITS}</span>
      </div>
      {/* Arrow column — flex: 0 0 24px */}
      <div className='w-6 shrink-0' />
    </div>

    {/* Rows */}
    <div className='min-h-[80px]'>
      {stateSettingsList.map(({ StateCode, IsPhoneVisitCommunicationTypeAllowed, DrugScreenHtml }) => (
        <StateSettingsRow
          key={StateCode}
          StateCode={StateCode}
          IsPhoneVisitCommunicationTypeAllowed={IsPhoneVisitCommunicationTypeAllowed}
          DrugScreenHtml={DrugScreenHtml}
          onSelectState={onSelectState}
        />
      ))}
    </div>
  </div>
)
